import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCGWltWiZHqyP9ygeI6zqDYHUKivGBleAk",
  authDomain: "construction-website-91dac.firebaseapp.com",
  projectId: "construction-website-91dac",
  storageBucket: "construction-website-91dac.appspot.com",
  messagingSenderId: "871639470267",
  appId: "1:871639470267:web:332fcc0e84d52c810d599e",
  measurementId: "G-610TCNT5VP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth };

export const verifyAdmin = async (user) => {
  if (!user) return false;
  try {
    const tokenResult = await user.getIdTokenResult();
  return !!tokenResult.claims.admin;
  } catch (error) {
    console.error("Error verifying admin status:", error);
    return false;
  }
};
